import classNames from 'classnames';
import {find, isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import React, {useCallback, useContext} from 'react';
import {connect} from 'react-redux';
import switchAccount from 'shared/actions/switch-account';
import ShowHideButton from 'shared/components/show-hide-button';
import {ImpostorModeContext} from 'src/components/ImpostorModeContext';
import {PlatformContext} from 'src/components/PlatformContext';
import ConnectionButton from './connection-button';
import ConnectionsList from './connections-list';
import {IonButton, IonButtons, IonToolbar} from '@ionic/react';
import NativeConnectionsList from './mobile-connections-list';

const Connections = ShowHideButton('Connections', ConnectionButton, ConnectionsList);

const propTypes = {
  switchUser: PropTypes.func.isRequired,
};

const ImpostorToolbar = (props) => {
  const impostorModeContext = useContext(ImpostorModeContext);
  const platformContext = useContext(PlatformContext);

  let originalUser;

  if (impostorModeContext.currentConnection) {
    originalUser = find(
      impostorModeContext.currentConnection.userConnectionInfo,
      (user) =>
        user.authenticated_user_id !== impostorModeContext.currentConnection.connectedUser._id
    );
  }

  const exitImpostorMode = useCallback(() => {
    if (!impostorModeContext.currentConnection || !originalUser) {
      return;
    }

    const returnUrl = localStorage.getItem('impersonationReturnUrl') || '/';
    localStorage.removeItem('impersonationReturnUrl');
    props.switchUser(originalUser.authenticated_user_id, returnUrl);
  }, [impostorModeContext.currentConnection, originalUser]);

  if (isEmpty(impostorModeContext.userConnections)) return null;

  if (!impostorModeContext.currentConnection) return null;

  if (platformContext.isIonic) {
    return (
      <IonToolbar className="shared-impostor-toolbar mobile">
        <div className="shared-impostor-toolbar-mobile-selector">
          Editing profile as:
          <NativeConnectionsList />
        </div>
        <IonButtons slot="end">
          <IonButton onClick={exitImpostorMode}>
            <span className="shared-impostor-toolbar-exit-button">Exit</span>
          </IonButton>
        </IonButtons>
      </IonToolbar>
    );
  }

  return (
    <div className={classNames('shared-impostor-toolbar')}>
      Editing profile as:
      <Connections className="shared-impostor-toolbar-chevron-container" />
      <button
        className="shared-impostor-toolbar-exit-button"
        type="button"
        onClick={exitImpostorMode}
      >
        Exit
      </button>
    </div>
  );
};

ImpostorToolbar.propTypes = propTypes;

export default connect(null, {
  switchUser: (id, redirectTo) =>
    switchAccount(id, 'Exit impostor mode from impostor toolbar', redirectTo),
})(ImpostorToolbar);
